module.exports = "<div>\n    <div ng-repeat=\"error in errors\">\n        <gw-wizard-single-error error=\"error\"></gw-wizard-single-error>\n    </div>\n</div>"